import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { CalendarObject, ResponseData } from "./common"

interface PropertyRequestData {
  propertyId: string
}

export interface PropertyRequest extends Partial<AxiosRequestConfig> {
  params: PropertyRequestData
}

export interface PropertyCalendarDataType {
  active: boolean
  averagePrice: number
  calendar: CalendarObject[]
  calendarRate: CalendarObject
  checkArrivalDeparture: boolean
  isHide: boolean
  maxProfit?: boolean
  status?: string
}

export interface PropertyCalendarResponseData extends ResponseData {
  data: PropertyCalendarDataType
}

export interface PropertyCalendarResponse extends AxiosResponse {
  data: PropertyCalendarResponseData
}

export function getPropertyCalendarApi(
  {
    params,
    method = "get",
    url = `/property/calendar-data/${params.propertyId}`,
    ...config
  }: PropertyRequest,
  axiosInstance: AxiosInstance,
): Promise<PropertyCalendarResponse> {
  const { propertyId, ...restParams } = params

  return axiosInstance({
    method,
    url,
    params: {
      ...restParams,
    },
    ...config,
  }) as Promise<PropertyCalendarResponse>
}
